import type { HelpFile } from '../../types/help'
import { AdminTestIds } from '../../../testids/AdminTestIds'

export const adminHelp: HelpFile = {
  docPage: '/docs/admin/overview',
  texts: {
    [AdminTestIds.adminWelcomeCard]:
      'Startseite des Admin-Bereichs — wählen Sie ein Werkzeug aus der Seitenleiste: Rollen, Rollenzuweisungen, Konnektoren, Fehlerprotokoll und Benachrichtigungsprotokoll.',
    [AdminTestIds.failureBadge]:
      'Anzahl fehlgeschlagener Hintergrund-Jobs, die Aufmerksamkeit erfordern — öffnet die Ausführungsliste gefiltert auf Fehler.',
  },
}
